import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

/**
 * Component for showing tipps on the bekocheck result page.
 */
@Component({
    selector: 'app-bkc-tipps',
    templateUrl: './bkc-tipps.component.html',
    standalone: false
})
export class BkcTippsComponent implements OnInit {

  /**
   * List of tipps to show
   */
  @Input() tipps: any[];

  /**
   * textkey for the headline
   */
  @Input() headline: string;

  /**
   * textkey for the teaser
   */
  @Input() teaser: string;

  /**
   * number of tipps to show on the start
   */
  @Input() tippCountDefault: number = null;

  /**
   * extra textkey postfix, based on the portal type.
   */
  @Input() textkeyPostfixForPortal: string;

  /**
   * current number of tipps to show
   */
  tippCount: number;

  /**
   * basis for all tipps textkeys
   */
  textkeyBase = 'bekochek.ergebnis.tipp.';

  /**
   * constructor
   */
  constructor(private translate: TranslateService) {
  }

  /**
   * initialize the component
   */
  ngOnInit(): void {
    // show all tipps at once on default
    if (this.tippCountDefault === null) {
      this.tippCountDefault = this.tipps.length;
    }

    // show default count on start
    this.tippCount = this.tippCountDefault;

    for (const tipp of this.tipps) {
      // all texts that are possible in the info
      const texts = {
        headline: this.textkeyBase + tipp.key + '.headline',
        teaser: this.textkeyBase + tipp.key + '.teaser',
        buttontext: this.textkeyBase + tipp.key + '.buttontext',
        link: this.textkeyBase + tipp.key + '.link' + this.textkeyPostfixForPortal,
        text: this.textkeyBase + tipp.key + '.text'
      };
      tipp.texts = texts;
      // get all text from the translator and set only the ones we got from the translator
      this.translate.get(Object.values(texts)).subscribe(data => {
        for (const text of Object.keys(texts)) {
          if (data.hasOwnProperty(texts[text]) && data[texts[text]] !== texts[text]) {
            tipp.texts[text] = texts[text];
          }
          else {
            // reset the tipp
            tipp.texts[text] = null;
          }
        }
      });
    }
  }

}
